import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useParams } from "react-router-dom";
import { ThemeProvider } from "next-themes";
import { Toaster } from "@/components/ui/sonner";
import { getToken } from "@/lib/api";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Overview from "@/pages/Overview";
import Help from "@/pages/Help";
import NewLet from "@/pages/NewLet";
import PublicCriteria from "@/pages/PublicCriteria";
import ApplicantFlow from "@/pages/ApplicantFlow";
import Properties from "@/pages/Properties";
import Developers from "@/pages/Developers";
import PropertyEditor from "@/pages/PropertyEditor";
import ApplicantProfile from "@/pages/ApplicantProfile";
import Settings from "@/pages/Settings";
import FixStep from "@/pages/FixStep";
import Organization from "@/pages/Organization";
import Billing from "@/pages/Billing";
import BillingPlans from "@/pages/BillingPlans";
import ApplyStart from "@/pages/ApplyStart";
import Join from "@/pages/Join";
import Landing from "@/pages/Landing";
import TenantStart from "@/pages/TenantStart";

const RequireAuth = ({ children }) => (getToken() ? children : <Navigate to="/login" replace />);
/** Signed-in agents land on their dashboard; everyone else sees the public front page. */
const Home = () => (getToken() ? <Overview /> : <Landing />);
const LetRedirect = () => <Navigate to={`/lets/${useParams().letId}/edit`} replace />;

function App() {
  return (
    <ThemeProvider attribute="class" defaultTheme="system" enableSystem disableTransitionOnChange storageKey="landin-theme">
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Home />} />
          <Route path="/welcome" element={<Landing />} />
          <Route path="/tenant" element={<TenantStart />} />
          <Route path="/applicants" element={<RequireAuth><Dashboard /></RequireAuth>} />
          <Route path="/help" element={<RequireAuth><Help /></RequireAuth>} />
          <Route path="/properties" element={<RequireAuth><Properties /></RequireAuth>} />
          <Route path="/developers" element={<RequireAuth><Developers /></RequireAuth>} />
          <Route path="/organization" element={<RequireAuth><Organization /></RequireAuth>} />
          <Route path="/settings" element={<RequireAuth><Settings /></RequireAuth>} />
          <Route path="/billing" element={<RequireAuth><Billing /></RequireAuth>} />
          <Route path="/billing/plans" element={<RequireAuth><BillingPlans /></RequireAuth>} />
          <Route path="/lets/new" element={<RequireAuth><NewLet /></RequireAuth>} />
          <Route path="/lets/:letId" element={<RequireAuth><LetRedirect /></RequireAuth>} />
          <Route path="/lets/:letId/edit" element={<RequireAuth><PropertyEditor /></RequireAuth>} />
          <Route path="/lets/:letId/applicants/:applicantId" element={<RequireAuth><ApplicantProfile /></RequireAuth>} />
          <Route path="/criteria/:token" element={<PublicCriteria />} />
          <Route path="/a/:token" element={<ApplicantFlow />} />
          <Route path="/a/:token/:stepKey" element={<ApplicantFlow />} />
          <Route path="/fix/:token" element={<FixStep />} />
          <Route path="/apply/:propertyKey" element={<ApplyStart />} />
          <Route path="/join/:token" element={<Join />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" />
    </div>
    </ThemeProvider>
  );
}

export default App;
